import { EventsRequests } from "@costory/types/endpoints/events"
import { Filters } from "@costory/types/filters"

import { Dayjs } from "@costory/shared/dayjs"

import { EventsEditModal } from "@costory/front/pages/Events/EventsForm"
import { useEditEventMutation } from "@costory/front/queries/events"

export const EditEventForm = ({
  data,
  isOpen,
  onClose,
  currentView,
  selectedDateRange,
}: {
  data: EventsRequests.Event
  isOpen: boolean
  onClose: () => void
  currentView: Filters
  selectedDateRange?: { from: Dayjs; to: Dayjs }
}) => {
  const { mutateAsync: editEvent } = useEditEventMutation({
    closeModal: onClose,
    currentView,
    selectedDateRange,
  })

  const onSave = async (event: EventsRequests.EventForm) => {
    await editEvent(event)
  }

  return (
    <EventsEditModal
      data={data}
      onSave={onSave}
      isOpen={isOpen}
      onClose={onClose}
    />
  )
}
